import * as React from "react";
import type { SVGProps } from "react";
const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#7B4BDD"
      fillRule="evenodd"
      d="M4 0a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm15.632 6.625c.765-.545 1.602-.035 1.36.828L18.586 16h4.264c.894 0 1.025 1.177.196 1.768l-10.678 7.607c-.765.545-1.602.035-1.36-.828l1.969-6.993 4.465-1.576h-5.48V16H9.151c-.895 0-1.026-1.177-.196-1.768z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogo;
